<main @fade>
    <nb-card [nbSpinner]="loading">
    <nb-card-header *ngIf="!isModal && editMode === false" i18n="@@Creating"><a [routerLink]="absolutePath">{{ title }}</a> / Добавление</nb-card-header>
    <nb-card-header *ngIf="!isModal && editMode === true" i18n="@@Updating"><a [routerLink]="absolutePath">{{ title }}</a> / {{ editName }}</nb-card-header>

      <nb-card-header  *ngIf="deleted" ><span i18n="@@RecordDeletedNoTags" class="badge text-bg-secondary">запись удалена</span>
        &nbsp; <button *ngIf="deleted" (click)="restore()" i18n-nbTooltip="@@Restore" nbTooltip="восстановить" nbButton status="info" size="tiny" ><nb-icon icon="repeat-outline"></nb-icon></button></nb-card-header>

      <nb-card-body>

      <div class="row">
        <div [ngClass]="isModal ? 'col-lg-12' : 'col-lg-7 n-part-left'">
          <app-create-update-form [base]="this"/>
        </div>
        <div class="col-lg-4">





        </div>

      </div>
    </nb-card-body>

  </nb-card>
</main>
